var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"small":"","icon":"","color":"primary--text"},on:{"click":function($event){$event.preventDefault();return _vm.handleClick.apply(null, arguments)}}},[_c('v-icon',[_vm._v(_vm._s(_vm.favouriteIcon))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }